import * as z from "zod/v4";
import { conciergeSkillsSchema } from "./common/concierge-skills-schema";

export const getConciergeSkillsSettings = {
  name: "getConciergeSkillsSettings" as const,
  input: z.null(),
  output: z.object({ settings: conciergeSkillsSchema }),
};
